import LessonCanvas from "@/components/admin/lesson-builder/LessonCanvas";
import { useParams } from "react-router-dom";

export default function LessonBuilderPage() {
  const { id } = useParams<{ id: string }>();
  return (
    <div className="pt-6 md:pt-8">
      <LessonCanvas lessonId={id || ""} />
    </div>
  );
}

